import cn from "@utils/cn";

const CLASS_NAMES = cn(`
  col-span-24
  px-0.5
  text-md
  leading-relaxed
  font-medium

  text-gallery-500
`);

const defaultProps = {
  label: "",
};

export default function FormBodySectionNote(props) {
  const {
    label,
  } = { ...defaultProps, ...props };

  /**************************************************************************************************/

  if (!label) return null;

  return (
    <div className={CLASS_NAMES}>
      {label}
    </div>
  );
}
